import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=1fc4fb58&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"
import style0 from "./Tab.vue?vue&type=style&index=0&id=1fc4fb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4fb58",
  null
  
)

export default component.exports